import { IAMDashboardState } from '@/modules/amDashboard/store/state';
import { MutationTree } from 'vuex';
import * as MT from './mutationsTypes';
import SubmissionRequest from '@/models/SubmissionRequest';
import { PaginationMeta, AmFilter } from '../types';
import { PensionScheme } from '../../pensionScheme/types';
import Submission from '@/models/Submission';
import Vue from 'vue';

/*--------------------------------------------------/
 * Dashboard Mutations
 *--------------------------------------------------*/
export const AMDashboardMutations: IAMDashboardMutations = {
  [MT.SET_SUBMISSION_REQUESTS]: (
    state: IAMDashboardState,
    submissionRequests: SubmissionRequest[]
  ) => (state.submissionRequests = submissionRequests),
  [MT.SET_PAGINATION_META]: (
    state: IAMDashboardState,
    paginationMeta: PaginationMeta
  ) => (state.amPaginationMeta = paginationMeta),
  [MT.SET_AM_FILTER]: (state: IAMDashboardState, amFilters: AmFilter) =>
    (state.amFilters = amFilters),
  [MT.SET_ORGANISATION_CLIENTS]: (
    state: IAMDashboardState,
    organizationClients: PensionScheme[]
  ) => (state.organizationClients = organizationClients),
  [MT.SET_SYNCING_SUBMISSIONS]: (
    state: IAMDashboardState,
    syncingSubmissions: boolean
  ) => (state.syncingSubmissions = syncingSubmissions),
  [MT.ADD_SUBMISSION_TO_SUBMISSION_REQUEST]: (
    state: IAMDashboardState,
    submission: Submission
  ) => {
    const indexOfSubmissionRequest = state.submissionRequests.findIndex(
      submissionRequest =>
        submissionRequest.investment?.id === submission.investment_id
    );
    if (indexOfSubmissionRequest === -1) {
      return;
    }
    const submissionRequest =
      state.submissionRequests[indexOfSubmissionRequest];
    submissionRequest.investment.submission = {
      ...submissionRequest.investment.submission,
      ...submission
    };
    Vue.set(
      state.submissionRequests,
      indexOfSubmissionRequest,
      submissionRequest
    );
  }
};

/*--------------------------------------------------/
 * Dashboard Mutations Tree Interface
 *--------------------------------------------------*/
export interface IAMDashboardMutations extends MutationTree<IAMDashboardState> {
  [MT.SET_SUBMISSION_REQUESTS](
    state: IAMDashboardState,
    submissionRequests: SubmissionRequest[]
  ): void;
  [MT.SET_PAGINATION_META](
    state: IAMDashboardState,
    paginationMeta: PaginationMeta
  ): void;
  [MT.SET_AM_FILTER](state: IAMDashboardState, amFilters: AmFilter): void;
  [MT.SET_ORGANISATION_CLIENTS](
    state: IAMDashboardState,
    organizationClients: PensionScheme[]
  ): void;
  [MT.SET_SYNCING_SUBMISSIONS](
    state: IAMDashboardState,
    syncingSubmissions: boolean
  ): void;
  [MT.ADD_SUBMISSION_TO_SUBMISSION_REQUEST](
    state: IAMDashboardState,
    submission: Submission
  ): void;
}
